import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import { ConsumablesFormStepSection } from "@jti/ui/components/ConsumablesFormStepSection";
import { Image } from "@jti/ui/components/Image";
import { RadioCard } from "@jti/ui/components/RadioCard";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import { ConsumablesSectionTitle } from "../ConsumablesFormSectionTitle";
import styles from "./ConsumablesPackagingFormatSection.module.scss";
export const ConsumablesPackagingFormatSection = ({ groupName, step, onChange, consumables, }) => {
    const { __ } = useTranslations();
    const { register, watch } = useFormContext();
    const onChangeHandler = (event) => {
        const newPackagingFormatId = event.target.value;
        onChange(newPackagingFormatId);
    };
    const registerProps = register(groupName, { onChange: onChangeHandler });
    const purchaseType = watch("purchaseType");
    return (_jsx(ConsumablesFormStepSection, { title: _jsx(ConsumablesSectionTitle, { translationKey: "consumablesForm.section.packaging_format.title", stepCount: step }), "data-testid": "packaging-options", children: consumables.packagingFormats.map((packagingFormat) => (_jsx(RadioCard, { groupName: groupName, value: packagingFormat.id, title: packagingFormat.label, subtitle: __("consumablesForm.packagingFormat.description", [
                packagingFormat.packagesPerBundle ?? 1,
                packagingFormat.formatQuantity * (packagingFormat.packagesPerBundle ?? 1),
            ]), icon: _jsx(Image, { url: packagingFormat.icon, className: styles.icon }), isDisabled: consumables.items.find((consumableItem) => consumableItem.packagingFormatId === packagingFormat.id) ===
                undefined, isUnavailable: purchaseType === "subscription" && packagingFormat.contentsType === "pack", ...registerProps }, packagingFormat.id))) }));
};
//# sourceMappingURL=ConsumablesPackagingFormatSection.js.map